import React, { useState, useEffect } from 'react';

function InputMoeda({
  name,
  initialValue = '0,00',
  onChange,
  className = '',
}) {
  // Converte "12,34" → "1234"
  function parseValorFormatado(valor) {
    if (!valor) return '0';
    return valor.replace(/\D/g, '') || '0';
  }

  // Converte "1234" → "12,34"
  function formatarMoeda(valor) {
    let n = parseInt(valor, 10);
    if (isNaN(n)) n = 0;

    return (n / 100)
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const [rawValue, setRawValue] = useState(
    parseValorFormatado(initialValue)
  );

  useEffect(() => {
    setRawValue(parseValorFormatado(initialValue));
  }, [initialValue]);

  function handleChange(e) {
    let v = e.target.value;
    let somenteNumeros = v.replace(/\D/g, '');

    if (somenteNumeros.length > 15) return;
    if (somenteNumeros === '') somenteNumeros = '0';

    setRawValue(somenteNumeros);

    if (onChange) {
      onChange({
        target: {
          name,
          value: formatarMoeda(somenteNumeros),
        },
      });
    }
  }

  return (
    <input
      type="text"
      name={name}
      className={`form-control ${className}`}
      value={formatarMoeda(rawValue)}
      onChange={handleChange}
      inputMode="numeric"
      pattern="[0-9]*"
    />
  );
}

export default InputMoeda;
